import DataTable from '../../../components/DataTable';
import React from 'react';
import useLocationsTableData from '../../../hooks/useLocationsTableData';

export const LocationsTab: React.FC = () => {
  const tableProps = useLocationsTableData({});
  return <DataTable {...tableProps} />;
};
